import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  FormGroup,
  Container,
  FormInput,
  Row,
  Col,
  FormFeedback,
} from "shards-react";
import { useFormik } from "formik";
import styled from "styled-components";
import baseUrl from "config/baseUrl";
import { Loading } from "views/Indicators/components";
import contactimg from "shared/assets/img/contact.jpeg";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import Layout from "shared/container/Layout";

const axios = require("axios").default;
const ResetPasswordContent = styled.div`
  padding: 30px 70px;
  color: #fff;
  border-radius: 6px;
  background-image: url(${contactimg});
  margin-left: -15px;
  margin-right: -15px;
  background-repeat: no-repeat;
  background-position: 50% 0;
  background-size: cover;
  height: calc(100vh - 60px);
`;
const ResetPassword = (props) => {
  const { match } = props;
  const { t, i18n } = useTranslation();
  const [token, setToken] = useState(match.params.token);
  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };
  const validate = (values) => {
    const errors = {};
    if (!values.password) {
      errors.password = t("common:resetPassword.PleaseEnterNewPassword");
    }
    if (!values.confirmpassword) {
      errors.confirmpassword = t("common:resetPassword.PleaseEnterReconfirmPassword");
    } else if (
      values.password &&
      values.confirmpassword &&
      values.password !== values.confirmpassword
    ) {
      errors.confirmpassword = t("common:resetPassword.PasswordsMatch");
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmpassword: "",
    },
    validate,
    onSubmit: (values) => {
      if (token) {
        var data = JSON.stringify({
          password: values.password,
        });

        var config = {
          method: "post",
          url: `${baseUrl}/v1/user/set-new-pass`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          data: data,
        };
        axios(config)
          .then((response) => {
            showNotify("แจ้งเตือน! เปลี่ยนรหัสผ่านสำเร็จ");
            setTimeout(() => {
              window.location.href = "/";
            }, 2000);
          })
          .catch((error) => {
            if(error.response.data.message){
          showNotify(error.response.data.message, "error");
        }else{
          showNotify(error.message, "error");
        }
          });
      }
    },
  });
  return (
    <Layout>
    <ResetPasswordContent>
      <ToastContainer />
      <Container>
        <Row>
          <Col sm={{ size: 6, order: 3, offset: 3 }}>
            <h5 className="bold text-center color-white">
            {t("common:resetPassword.ChangeNewPassword")}
            </h5>
            {/* <h6 className="bold color-white">เปลี่ยนรหัสผ่านใหม่</h6> */}
            <Form onSubmit={formik.handleSubmit}>
              <FormGroup>
                <label>
                {t("common:resetPassword.NewPassword")}<span className="color-red">*</span>
                </label>
                <FormInput
                  type="password"
                  name="password"
                  placeholder={t("common:resetPassword.NewPassword")}
                  onChange={formik.handleChange}
                  invalid={!!formik.errors.password}
                  value={formik.values.password}
                />
                {formik.errors.password && (
                  <FormFeedback>{formik.errors.password}</FormFeedback>
                )}
              </FormGroup>
              <FormGroup className="mb-5">
                <label>
                {t("common:resetPassword.ReconfirmPassword")}<span className="color-red">*</span>
                </label>
                <FormInput
                  type="password"
                  name="confirmpassword"
                  placeholder={t("common:resetPassword.ReconfirmPassword")}
                  onChange={formik.handleChange}
                  invalid={!!formik.errors.confirmpassword}
                  value={formik.values.confirmpassword}
                />
                {formik.errors.confirmpassword && (
                  <FormFeedback>{formik.errors.confirmpassword}</FormFeedback>
                )}
              </FormGroup>
              <hr />
              <Row>
                <Col md="6">
                  <Button
                    className="btn btn-white w-100 mb-3"
                    onClick={() => (window.location.href = "/")}
                  >
                    {t("common:resetPassword.Home")}
                  </Button>
                </Col>
                <Col md="6">
                  <Button type="submit" className="btn btn-success w-100 mb-3">
                  {t("common:resetPassword.ConfirmPassword")}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </ResetPasswordContent>
    </Layout>
  );
};

export default ResetPassword;
